<template>
  <div>
    <div class="table__block">
      <el-table
        v-if="showTable"
        :data="dataTable"
        style="width: 100%"
        height="513"
      >
        <el-table-column
          label="Tên kỳ"
        >
          <el-table-column label="Kê khai theo mã nhân viên" min-width="100" align="center">
            <template slot-scope="scope">
              <a
                :href="
                  scope.row.salary_period_id == 'Tổng cộng'
                    ? 'javascipt:0'
                    : `/admin/SalaryEmployee/list?salary_period_id=${scope.row.salary_period_id}&tab=Insurance`
                "
                class="custom__link"
                @click="goToEmployeeSalary(scope.row.salary_period_id)"
              >
                {{ getNamePeriod(scope.row.salary_period_id) }}
              </a>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          label="Trích nộp bảo hiểm"
        >
          <el-table-column
            label="Bảo hiểm xã hội"
            prop="social_insurance"
            min-width="90"
            align="center"
          >
            <template slot-scope="scope">
              {{ MethodService.formatCurrency(scope.row.social_insurance) }}
            </template>
          </el-table-column>
          <el-table-column
            label="Bảo hiểm y tế"
            prop="health_insurance"
            min-width="90"
            align="center"
          >
            <template slot-scope="scope">
              {{ MethodService.formatCurrency(scope.row.health_insurance) }}
            </template>
          </el-table-column>
          <el-table-column
            label="Bảo hiểm thất nghiệp"
            prop="unemployment_insurance"
            min-width="90"
            align="center"
          >
            <template slot-scope="scope">
              {{ MethodService.formatCurrency(scope.row.unemployment_insurance) }}
            </template>
          </el-table-column>
          <el-table-column
            label="Tổng"
            prop="total"
            min-width="90"
            align="center"
          >
            <template slot-scope="scope">
              {{ MethodService.formatCurrency(scope.row.total) }}
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <div class="button__block mt-3 text-right">
      <el-button
        :disabled="dataTable.length == 0"
        type="primary"
        class="btn-export"
        @click="exportReport"
      >
        <i class="icon icon24-Download"></i>
        <span>Xuất báo cáo</span>
      </el-button>
    </div>
  </div>
</template>
<script>
import MethodService from '../../../../service/MethodService'
import InsuranceApi from '../../../../moduleApi/InsuranceApi'
import EventBus from "@/service/EventBus"

export default {
  props: {
    fromPeriodProp: {
      type: String,
      default: undefined
    },
    toPeriodProp: {
      type: String,
      default: undefined
    },
    listSalaryPeriod: {
      type: Array,
      default: (() => [])
    },
    keySubmit: {
      type: String,
      default: undefined
    },
  },
  watch: {
    keySubmit(newVal) {
      if (this.$route.query.tab && this.$route.query.tab == 'insurance') {
        this.dataTable = []
        setTimeout(() => {
          this.getDataInsurance()
        }, 500)
      }
    },
  },
  data() {
    return {
      MethodService,
      dataTable: [],
      showTable: true,
    }
  },
  methods: {
    exportReport() {
      MethodService.exportInssurance(
        this.dataTable,
        this.listSalaryPeriod,
        this.getNamePeriod(this.fromPeriodProp),
        this.getNamePeriod(this.toPeriodProp)

      )
    },
    goToEmployeeSalary(salaryPeriodId) {
      if (salaryPeriodId == 'Tổng cộng') return
      this.$router.push({
        name: 'Admin-SalaryEmployee-list',
        query: {
          salary_period_id: salaryPeriodId,
          tab: 'Insurance'
        }
      }).catch(() => {})
    },
    async getDataInsurance() {
      let data = {
        from_date: this.getStartTimePeriod(this.fromPeriodProp),
        to_date: this.getEndTimePeriod(this.toPeriodProp)
      }
      const getInsuranceApiRes = await InsuranceApi.GetInsurances(data)
      this.dataTable = this.changeData(getInsuranceApiRes.result)
    },
    changeData(data) {
      if (data.length == 0) return data
      let obj = {
        salary_period_id: 'Tổng cộng',
        social_insurance: 0,
        health_insurance: 0,
        unemployment_insurance: 0,
        total: 0,
      }
      data.forEach(item => {
        item.total =  parseFloat(item.social_insurance) + parseFloat(item.health_insurance) + parseFloat(item.unemployment_insurance)
      })
      data.forEach(item => {
        obj.social_insurance += item.social_insurance
        obj.health_insurance += item.health_insurance
        obj.unemployment_insurance += item.unemployment_insurance
        obj.total += item.total
      })
      data.push(obj)
      return data
    },
    getNamePeriod(id) {
      if (id == 'Tổng cộng') return id
      let a = this.listSalaryPeriod.find(item => item.id == id)
      return a.name_period.replace('Tháng ','')
    },
    // A function to get the start time of a period.
    getStartTimePeriod(id) {
      let period = this.listSalaryPeriod.find(e => e.id == id)
      return period && period.from_date ? period.from_date : undefined
    },
    // A function to get the end time of a period.
    getEndTimePeriod(id) {
      let period = this.listSalaryPeriod.find(e => e.id == id)
      return period && period.before_to_date ? period.before_to_date : undefined
    },
  },
  created() {
    EventBus.$off('changeSizeMenuInsurance')
    EventBus.$on('changeSizeMenuInsurance', () => {
      this.showTable = false
      setTimeout(() => {
        this.showTable = true
      }, 50)
    })
  }
}
</script>
<style lang="scss" scoped>
.table__block {
  min-height: 513px;
}
.custom__link {
  color: #1E3CD7;
  font-family: 'LexendDeca Regular';
  font-weight: 300;
  font-size: 15px;
  line-height: 24px;
  text-decoration: underline;
}
</style>
